export default {
  getSaleDetailDailySummary: {
    url: '/getSaleDetailDailySummary',
    method: 'post',
    desc: '首页统计信息'
  },
  getSalesRank: {
    url: '/orders/getSalesRank',
    method: 'post',
    desc: '首页销量排行榜'
  },
  analyseDay: {
    url: '/operationads/analyse/daySummary',
    method: 'post',
    desc: '广告表现'
  },
  realtimeSalesStatistic: {
    url: '/realtimeSalesStatistic',
    method: 'post',
    desc: '即时汇总接口'
  },
  realtimeSalesStatisticDetail: {
    url: '/realtimeSalesStatisticDetail',
    method: 'post',
    desc: '汇总明细接口'
  },
  fbaStorageStatistic: {
    url: '/fbaStorageStatistic',
    method: 'post',
    desc: 'FBA库存接口'
  },
  fbaInventoryAgedStatistic: {
    url: '/fbaInventoryAgedStatistic',
    method: 'post',
    desc: 'FBA库龄报表数据'
  },
  getRefundRank: {
    url: '/getRefundRank',
    method: 'post',
    desc: '退款排行榜'
  },
  getCountryOrderDistribution: {
    url: '/getCountryOrderDistribution',
    method: 'post',
    desc: '国家订单分布'
  },
  getRegionOrderDistribution: {
    url: '/getRegionOrderDistribution',
    method: 'post',
    desc: '国家地区订单分布'
  },
  getCountryRefundDistribution: {
    url: '/getCountryRefundDistribution',
    method: 'post',
    desc: '国家退款分布'
  },
  getRegionRefundDistribution: {
    url: '/getRegionRefundDistribution',
    method: 'post',
    desc: '国家地区退款分布'
  },
  getDashboardReviewStatistics: {
    url: '/getDashboardReviewStatistics',
    method: 'post',
    desc: 'review统计数据获取'
  },
  getDashboardFeedbackStatistics: {
    url: '/getDashboardFeedbackStatistics',
    method: 'post',
    desc: 'Feedback统计数据获取'
  },
  getDashboardSaleStatistics: {
    url: '/getDashboardSaleStatistics',
    method: 'post',
    desc: '结算概览'
  },
  getDashboardMonitorStatistics: {
    url: '/getDashboardMonitorStatistics',
    method: 'post',
    desc: '商品监控'
  },
  getDashboardRefundStatistics: {
    url: '/getDashboardRefundStatistics',
    method: 'post',
    desc: '退款分析'
  }
}
